module.exports = __webpack_public_path__ + "static/img/qrcode-kesci.3fb6917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode-kesci.png
// module id = Sbou
// module chunks = 0